import { parentDetailsData } from "../mock";
import { getAxiosInstance } from "../api";
import { ChildrenStoreData } from "src/shared/types/src";
import { API_PART_URL } from "src/shared/config/src";
// import { API_PART_URL } from "@parent-app/config";
// import { ChildrenStoreData } from "@parent-app/types";

export const getParentDetails = async ({ child }: { child: ChildrenStoreData }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();

    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;

    return retryAxios.get(`${child.instanceUrl}${API_PART_URL}/child/${child.childId}/parent-details`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}